<template>
  <div class="wrapper">
    <section class="answer-one answer">
      <div class="container answer__container">
        <div class="answer__block--title answer__bg--thee">
          <span class="levels__love-bg">
            <picture>
              <source srcset="~@/assets/img/level-love-3.avif" type="image/avif">
              <source srcset="~@/assets/img/level-love-3.webp" type="image/webp">
              <img loading="lazy" src="~@/assets/img/level-love-3.png" class="image" width="54" height="166" alt="Love">
            </picture>
            </span>
          <h2 class="answer__title">Уровень 3</h2>
          <p class="answer__subtitle">Недостаточный:</p>
        </div>
        <div class="answer__content">
          <div class="process-bar__label">Потенциал любовной энергии</div>
          <div class="process-bar">
            <div class="process-bar__line result-3"></div>
            <div class="process-bar__value">96%</div>
          </div>
          <div class="process-bar-listing">
            <div class="process-bar-listing__title">Любовная энергия на данный момент:</div>
            <div class="process-bar-list__label">Любовь к себе</div>
            <div class="process-bar-list">
              <div class="process-bar-list__line result-3_list_1"></div>
              <div class="process-bar-list__value">17%</div>
            </div>
            <div class="process-bar-list__label">Любовь к окружающим </div>
            <div class="process-bar-list">
              <div class="process-bar-list__line result-3_list_2"></div>
              <div class="process-bar-list__value">25%</div>
            </div>
            <div class="process-bar-list__label">Любовь к жизни</div>
            <div class="process-bar-list">
              <div class="process-bar-list__line result-3_list_3"></div>
              <div class="process-bar-list__value">28%</div>
            </div>
          </div>
          <div class="text-icon">
            <img src="@/assets/img/svg/icon_1_text.svg" />
            <p>Ваш потенциал любовной энергии составляет целых 96%! Это указывает на то,
              что <span>вы способны как сама любить по-настоящему,
              так и принимать любовь другого человека.</span></p>
          </div>
          <p class="answer__content--text">Вместе с достойным мужчиной
            <span>вы можете создать прочный
            и долговременный союз,</span>
            в котором сможете обрести истинное счастье. При этом
            на данном этапе жизни у вас недостаточный уровень энергии любви, который характеризуется заниженной самооценкой, тревожностью и зависимости
            от партнера. Вы можете сравнивать себя с другими, искать в себе изъяны и даже ревновать мужчину.<br /><br />
            Вам часто встречаются неценящие вас кандидаты, потому что ваш уровень энергии любви
            <span>не позволяет притягивать</span> состоявшихся мужчин.
          </p>
          <div class="text-icon icon-top m28">
            <img src="@/assets/img/svg/icon_2_text.svg" />
            <p>Если вы не начнете работать над своей любовной энергией, в вашей жизни будет и дальше повторяться один и тот же негативный сценарий.</p>
          </div>
          <p class="answer__content--text no-margin">Вы <span>продолжите</span> привлекать
            к себе партнеров с таким же недостаточным уровнем, как у себя, и не сможете создать полноценные и гармоничные отношения. Поэтому вам необходимо стремиться
            к высокому уровню.
          </p>
          <p class="answer__content--text m28">Вам необходимо поверить в себя и в собственные силы, не соглашаться на все, что вам предлагают, а самой делать выбор. Только так вы сможете поднять свой уровень энергии любви. </p>
          <div class="block-text">
            <div class="block-text__title">Высокий уровень любви даст вам:</div>
            <div class="block-text__text">— здоровую самооценку;
            </div>
            <div class="block-text__text">
              — умение любить себя такой, какая вы есть;
            </div>
            <div class="block-text__text">
              — способность быть любимой;
            </div>
            <div class="block-text__text">
              — счастливые отношения;
            </div>
            <div class="block-text__text">
              — внутреннее равновесие;
            </div>
            <div class="block-text__text">
              — избавление от одиночества.
            </div>
          </div>

          <div class="rs-title">Персональные рекомендации для вас:</div>
          <div class="rs-block">
            <div class="rs-block__table">
              <div class="rs-block__number">01</div>
              <div class="rs-block__subtitle">Техника <br>
                “Плюс/Минус”. </div>
            </div>
            <div class="rs-block__text">Возьмите лист бумаги и разделите на 2 части. С одной стороны напишите список своих достоинств, а с другой — недостатков. Подумайте, как вам развить плюсы и как бороться с минусами. Начинайте работать в этом направлении. А каждый раз, когда вам кажется, что вы вновь потеряли уверенность, перечитывайте список с перечислением своих преимуществ.</div>
          </div>
          <div class="rs-block">
            <div class="rs-block__table">
              <div class="rs-block__number">02</div>
              <div class="rs-block__subtitle icon_number"> Амулет
                <br />“Энергия любви”.</div>
            </div>
            <div class="rs-block__text icon_end">Он настраивается под вашу <br>энергетику методом <br>индивидуального заряда, поэтому способен решать ваши <br>персональные задачи и проблемы <br>в личной жизни. Амулет поможет <br>вам стать увереннее и смелее <br>через повышение самооценки и принятие себя. Это откроет вам <br>путь к гармонии, а гармоничная <br>личность не сравнивает себя с <br>другими, не завидует им и не ревнует. <br>Как работает амулет и чем он вам поможет — читайте тут</div>
            <div class="more">
              <a class="info__button btn_rs btn" :href="url" onclick="ym(56736205,'reachGoal','amuletslovetest')">Заказать амулет</a>
            </div>
          </div>
          <div class="rs-block">
            <div class="rs-block__table">
              <div class="rs-block__number">03</div>
              <div class="rs-block__subtitle">Практика от зависти.</div>
            </div>
            <div class="rs-block__text">Когда вас одолевает это разрушительное чувство, мысленно ставьте что-то ему в противовес. Например, если вы завидуете успеху подруги, подумайте о том, в чем успешны сами, за что вы можете себя похвалить и чем вам можно гордиться. При регулярном применении такое замещение научит вас быстро пресекать зависть.
            </div>
          </div>
        </div>
      </div>
    </section>
    <FooterResult />
  </div>
</template>

<script>
import FooterResult from "@/components/FooterResult";

export default {
  name: "Result3",
  components: {FooterResult},
  computed: {
    utm() {
      return this.$store.getters['utm']
    },
    url() {
      let link = 'https://store.taroirena.ru/shop/amulety/braslet-energiya-lyubvi/'
      if(this.utm.utm_source) {
        link += '?utm_source=' + this.utm.utm_source
      }
      if(this.utm.utm_medium) {
        link += '&utm_medium=' + this.utm.utm_medium
      }
      if(this.utm.utm_campaign) {
        link += '&utm_campaign=' + this.utm.utm_campaign
      }
      if(this.utm.utm_content) {
        link += '&utm_content=' + this.utm.utm_content
      }
      if(this.utm.utm_term) {
        link += '&utm_term=' + this.utm.utm_term
      }
      return link
    }
  }
}
</script>